import * as React from "react";
const SvgBell = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M9.99944 4.16667C11.1929 4.16667 12.3375 4.58809 13.1814 5.33824C14.0253 6.08838 14.4994 7.1058 14.4994 8.16667C14.4994 9.80755 14.8703 11.0363 15.3513 11.9399C15.9658 13.0944 16.2731 13.6716 16.256 13.8035C16.2361 13.9574 16.2107 13.9997 16.0842 14.0896C15.9758 14.1667 15.4365 14.1667 14.358 14.1667H5.64092C4.56235 14.1667 4.02307 14.1667 3.91466 14.0896C3.78821 13.9997 3.7628 13.9574 3.74286 13.8035C3.72577 13.6716 4.03303 13.0944 4.64756 11.9399C5.12853 11.0363 5.49944 9.80755 5.49944 8.16667C5.49944 7.1058 5.97355 6.08838 6.81746 5.33824C7.66137 4.58809 8.80597 4.16667 9.99944 4.16667ZM9.99944 4.16667V2.5M7.79444 16.6667C8.38298 17.1861 9.15607 17.5013 10.0028 17.5013C10.8495 17.5013 11.6226 17.1861 12.2111 16.6667",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);
export default SvgBell;
